var React = require('react');

function PostLTriangleMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-45.8516 104.659L75.2661 207.835M-45.8516 104.659L55.6451 112.032M-45.8516 104.659L130.983 72.4313M75.2661 207.835L55.6451 112.032M75.2661 207.835L130.983 72.4313M55.6451 112.032L130.983 72.4313","stroke":"#DADADA"}));
}

PostLTriangleMobile.defaultProps = {"width":"175","height":"223","viewBox":"0 0 175 223","fill":"none"};

module.exports = PostLTriangleMobile;

PostLTriangleMobile.default = PostLTriangleMobile;
